import { Box, Grid } from "@mui/material";
import pxToRem from "theme/base/pxToRem";
import { useDispatch, useSelector } from "react-redux";
import {
  categoryOptionSelector,
  formFilterHrReportSelector,
} from "modules/DeclareLeave/redux/selector";
import { useFormFlow, useFormUpdate, useRefsManager } from "helper/customHook";
import FormSelect from "components/common/Form/FormSelect";
import { FormInput } from "components/common/Form";
import { memo } from "react";

import { resetControlPageFilter } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  CATEGORY_TYPE,
  getCategoryOptionStart,
} from "modules/DeclareLeave/redux/getCategoryOption";
import {
  EXPORT_TYPE,
  formFilterHrReportUpdate,
} from "modules/DeclareLeave/redux/formFilterHrReport";
import {
  getHrReportStart,
  resetHrReport,
} from "modules/DeclareLeave/redux/getHrReport";

const FilterReport = memo(() => {
  const dispatch = useDispatch();
  const { type } = useSelector(formFilterHrReportSelector);

  const formData = useSelector(formFilterHrReportSelector);
  const { DEPT_LEVEL1, DEPT_LEVEL2, WORKING_AREA, TIMEKEEPING_TYPE } =
    useSelector(categoryOptionSelector);

  const { attachRef, elementsRef } = useRefsManager();

  const handleFilter = () => {
    dispatch(resetControlPageFilter({ id: "hrReport", limit: 100 }));
    dispatch(resetHrReport());
    dispatch(getHrReportStart());
  };

  const { handleInputChange, handleSelectChange } = useFormUpdate(
    formFilterHrReportUpdate,
    () => {
      handleFilter();
    }
  );

  const { handleNext } = useFormFlow(elementsRef, []);

  const itemGrid = type === EXPORT_TYPE.CHECK_IN_OUT ? 2.4 : 3;

  return (
    <Box sx={{ marginBlock: pxToRem(20), width: "100%" }}>
      <Grid container spacing={2} sx={{ width: "100%" }}>
        <Grid item lg={itemGrid} md={6} xs={12}>
          <FormSelect
            name={"workingAreaCode"}
            formData={formData}
            formErrors={{}}
            placeholder="Khu vực"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={WORKING_AREA || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={itemGrid} md={6} xs={12}>
          <FormSelect
            name={"departmentLevel1Code"}
            formData={formData}
            formErrors={{}}
            placeholder="Đơn vị cấp 1"
            // label="Người liên quan (nếu có)"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={(name) => (e) => {
              handleSelectChange(name)(e);
              dispatch(
                getCategoryOptionStart({
                  categoryType: CATEGORY_TYPE.DEPT_LEVEL2,
                  departmentCode: e,
                })
              );
            }}
            onKeyDown={(name: string) => handleNext(name)}
            options={DEPT_LEVEL1 || []}
            fontSize={14}
          />
        </Grid>
        <Grid item lg={itemGrid} md={6} xs={12}>
          <FormSelect
            name={"departmentLevel2Code"}
            formData={formData}
            formErrors={{}}
            placeholder="Đơn vị cấp 2"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={DEPT_LEVEL2 || []}
            fontSize={14}
          />
        </Grid>
        {type === EXPORT_TYPE.CHECK_IN_OUT && (
          <Grid item lg={itemGrid} md={6} xs={12}>
            <FormSelect
              name={"timekeepingType"}
              formData={formData}
              formErrors={{}}
              placeholder="Đối tượng chấm công"
              labelColor={"textSecondary"}
              attachRef={attachRef}
              onChange={handleSelectChange}
              onKeyDown={(name: string) => handleNext(name)}
              options={TIMEKEEPING_TYPE || []}
              fontSize={14}
            />
          </Grid>
        )}

        {/* <Grid item lg={2} md={4} xs={6}>
          <FormSelect
            name={"leaveReasonCode"}
            formData={formData}
            formErrors={{}}
            placeholder="Loại hình nghỉ"
            // label="Người liên quan (nếu có)"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleSelectChange}
            onKeyDown={(name: string) => handleNext(name)}
            options={LEAVE_REASON || []}
            fontSize={14}
          />
        </Grid> */}
        <Grid item lg={itemGrid} md={6} xs={12}>
          <FormInput
            name={"search"}
            formData={formData}
            formErrors={{}}
            placeholder="Tìm nhân sự"
            labelColor={"textSecondary"}
            attachRef={attachRef}
            onChange={handleInputChange}
            onKeyDown={(name: string) => handleNext(name)}
            inputProps={{ sx: { padding: pxToRem(10) } }}
            fontWeight={400}
            fontSize={14}
          />
        </Grid>
      </Grid>
    </Box>
  );
});
export default FilterReport;
